import Axios from 'axios'
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { getUser } from '../../../../actions/session'
import { CARRIER_RESTRICTION_USER,CARRIER_RESTRICTION_USER_UPDATE, LOGIN_URL } from '../../../../config/rest_endpoints'
import CustomLoader from '../../../common/loader'
import { Notifications } from '../../../common/notification'

class RestrictionTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            userId: this.props.userId,
            data:[],
            isGetting:false,
            updatePayload:null,
            isLoginURL: false
        }
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.updateCarrier = this.updateCarrier.bind(this)
    }

    componentDidMount() {
        this.getRestrictionUser()
    }

    getRestrictionUser() {
        const {User,userId} = this.state
        var headers = { 'Authorization': "Bearer " + User.token }
        this.setState({isGetting:true})
        Axios.get(`${CARRIER_RESTRICTION_USER}/${userId}/account-restriction`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                var resp = res.data.data
                this.setState({
                    data: resp,
                    isGetting:false,
                })
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
            })
        })
    }

    toggleSwitch(obj,id) {
        const {data,User,userId} = this.state
        let update = {
            id: obj.id,
            accountName:obj.accountName,
            active:!obj.active
        }
        data.splice(id, 1, update);
        var payload = {
            "data":data
        }
        this.setState({updatePayload:payload})
        
    }

    updateCarrier() {
        const {updatePayload,User,userId,data} = this.state
        console.log('updatePayload :>> ', updatePayload);
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        var payload = {
            "data":data
        }
        if(updatePayload === null) {
           
            this.setState({updatePayload:payload,isGetting:false})
        }
        else {
            Axios.put(`${CARRIER_RESTRICTION_USER_UPDATE}/${userId}/account-restriction/update`,updatePayload, { headers }).then(res => {
                if (res) {
                    this.getRestrictionUser()
                    this.setState({isGetting:false})
                    console.log('res :>> ', res);
                }
            }).catch(err => {
                const alert = err.response
                console.log(`alert.data.message`, alert.data.message)
                if (alert.data.message === 'invalid or expired jwt') {
                    localStorage.removeItem('user');
                    this.setState({ isLoginURL: true })
                    Notifications.notify(alert.data.message, "Token Expire", "error")
                }
                Notifications.notify(alert.data.message, "Failed", "error")
                this.setState({
                    isGetting: false,
                })
            })
        }
       
    }

    renderRestrictionUser() {
        const { data } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (data === null) {
            return nullData
        }
        else {
            return data.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.accountName}</td>
                        <td style={{textAlign:'center'}}>{row.active === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                       <td style={{textAlign:'center'}}>
                        <input className='myCheck' type="checkbox" onChange={this.toggleSwitch.bind(this, row,idx)} checked={row.active} />
                        </td>
                    </tr>
                )
            })
        }
    }
    
    render() {
        console.log('updatePayload :>> ', this.state.updatePayload);
        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        return (
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div className="card-header header-elements-inline p-0 py-1 mb-2">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                            <button type="submit" className="main-button btn btn-sm btn-success ml-3" onClick={this.updateCarrier} >Update Restriction <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header border-0">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{overflowX: 'auto'}}>
                            <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Name</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Status</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {this.state.isGetting ? <CustomLoader /> : this.renderRestrictionUser()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer">
                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to 10 of 15 entries</div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>
        )
    }
}
export default RestrictionTable